module.exports = "<label ng-if=\"!vm.error\" for=\"{{vm.keyName}}\">{{ vm.keyName | translate}}</label>\n<label ng-if=\"vm.error\" class=\"configureCustomer__error\"><i class=\"configureCustomer__icon icon warning-icon\"></i>{{ vm.error | translate }}</label>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/customerIntegrationInput/customerIntegrationInput.html
// module id = 540
// module chunks = 1